export function renderRecentCourse(user) {

    const formatNames = values =>
        values?.split(/[_-\s]/).map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');

    if (user?.educations?.length && Array.isArray(user?.educations)) {
        const edu = user.educations[user.educations.length - 1]
        return formatNames(edu.courseName) || formatNames(edu.courseCategory)
    }
    return null
}